<template>
  <section>
    <fragment>
      <modal
        class="custom-modal incentive-modal"
        :class="{ 'incentive-modal--large': isModalLarge }"
        v-model="open"
        :before-close="closeModal"
        ref="modal"
        :footer="false"
        size="lg"
        id="incentiveModal"
      >
        <template #header>
          <a
            role="button"
            href="#"
            class="custom-modal__close"
            type="button"
            @click.prevent="closeModal"
          >
            <span class="mi mi-cross"></span>
          </a>
        </template>
        <div>
          <div class="incentive-modal__top">
            <img class="img-responsive" alt="" :src="headerImageUrl" />
            <h1 class="incentive-modal__header">
              Nasi klienci do swojego<br />zamówienia często dodają:
            </h1>
          </div>
          <template v-if="isNDE">
            <template v-for="type in getNDEConfectionTypeOrder()">
              <section v-if="hasNDEConfectionByType(product, type)" :key="type" class="incentive-modal__section">
                <h2 class="incentive-modal__section-title">
                  {{ getConfectionHeader(type) }}
                </h2>
                <p v-if="isConfectionTypeExclusive(type)" class="incentive-modal__section-subtitle">
                  Uwaga! Możesz wybrać <b>tylko jedną</b> opcję personalizacji.
                </p>
                <p v-else class="incentive-modal__section-subtitle">
                  Możesz wybrać wszystkie opcje
                </p>
                <div class="incentive-modal__items">
                  <confection-tile
                    v-for="item in getNDEConfectionByType(product, type)"
                    :key="item.idproducts"
                    :item="item"
                    :inCart="isItemInCart(item, type)"
                    :imageUrl="getImageUrl(item)"
                    @add-to-cart="addToCart(item, type)"
                  >
                    <template #button>
                      <button
                        v-if="isConfectionAmountEnterable(item)"
                        type="button"
                        class="btn btn-outline-primary confection-tile__add-to-cart"
                        @click="closeModal"
                      >
                        Wróć do usług dodatkowych
                      </button>
                    </template>
                  </confection-tile>
                </div>
              </section>
            </template>
          </template>
          <template v-else>
            <section v-if="hasConfection" class="incentive-modal__section">
              <h2 class="incentive-modal__section-title mb-4">
                {{ isCoupon ? "Koperta ozdobna" : "Etui ozdobne" }}
              </h2>
              <div class="incentive-modal__items">
                <confection-tile
                  v-for="item in getConfection"
                  :key="item.idproducts"
                  :item="item"
                  :imageUrl="getImageUrl(item)"
                >
                  <template #button>
                    <button
                      type="button"
                      class="btn btn-outline-primary confection-tile__add-to-cart"
                      @click="closeModal"
                    >
                      Wróć do usług dodatkowych
                    </button>
                  </template>
                </confection-tile>
              </div>
            </section>
            <section
              v-if="hasConfectionService"
              class="incentive-modal__section"
            >
              <h2 class="incentive-modal__section-title mb-4">
                Dodatkowe usługi
              </h2>
              <div class="incentive-modal__items">
                <confection-tile
                  v-for="item in getConfectionService"
                  :key="item.idproducts"
                  :item="item"
                  :imageUrl="getImageUrl(item)"
                >
                  <template #button>
                    <button
                      type="button"
                      class="btn btn-outline-primary confection-tile__add-to-cart"
                      @click="closeModal"
                    >
                      Wróć do usług dodatkowych
                    </button>
                  </template>
                </confection-tile>
              </div>
            </section>
          </template>
        </div>
      </modal>
    </fragment>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import {
  checkProductsIsCoupon,
} from '@/utils/categoryUtils';
import ConfectionTile from '@/components/ConfectionTile.vue';
import {
  getConfectionHeader,
  getNDEConfectionTypeOrder,
  getNDEConfectionByType,
  hasNDEConfectionByType,
  isConfectionAmountEnterable,
  isConfectionTypeExclusive,
} from '@/utils/confection/nde';
import { resolveConfectionIncentiveModalImageName } from '@/utils/confection/modals';

const LARGE_MODAL_MIN_PRODUCTS_COUNT = 3;

export default {
  name: 'confectionIncentiveModal',
  components: {
    ConfectionTile,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getConfectionHeader,
    getNDEConfectionByType,
    hasNDEConfectionByType,
    isConfectionTypeExclusive,
    isConfectionAmountEnterable,
    getNDEConfectionTypeOrder,
    isNormalProductInCart(item) {
      return !!this.selectedConfectionItems[item.slug];
    },
    isExclusiveProductInCart(item) {
      return this.selectedExclusiveItem === item.slug;
    },
    isItemInCart(item, type) {
      return this.isConfectionTypeExclusive(type)
        ? this.isExclusiveProductInCart(item)
        : this.isNormalProductInCart(item);
    },
    addToCartNormalItem(item) {
      this.$store.dispatch('confection/handleConfectionItemSelection', {
        selectedItem: item.slug,
        isSelected: true,
      });
    },
    addToCartExclusiveItem(item) {
      this.$store.dispatch('confection/setSelectedExclusiveItem', item.slug);
    },
    addToCart(item, type) {
      if (this.isConfectionTypeExclusive(type)) {
        this.addToCartExclusiveItem(item);
      } else {
        this.addToCartNormalItem(item);
      }
    },
    closeModal() {
      this.$emit('update:open', false);
    },
    getImageUrl(item) {
      const parentId = this.$store.getters.allProducts[0].idproducts;
      const imageName = resolveConfectionIncentiveModalImageName(
        parentId,
        item.product_category,
        item.slug,
      );
      return this.createMediaUrl(imageName);
    },
    createImageUrl(imageName) {
      return `${process.env.VUE_APP_BASE_URL}/img/${imageName}`;
    },
    createMediaUrl(imageName) {
      return `${process.env.VUE_APP_BASE_URL}/media/${imageName}`;
    },
  },
  computed: {
    ...mapState({
      selectedExclusiveItem: state => state.confection.selectedExclusiveItem,
      selectedConfectionItems: state => state.confection.selectedConfectionItems,
    }),
    product() {
      return this.$store.getters.deliveriesProducts(this.delivery_id)[0];
    },
    headerImageUrl() {
      return this.createImageUrl('icon-incentive.svg');
    },
    hasConfection() {
      return this.getConfection.length > 0;
    },
    hasConfectionService() {
      return this.getConfectionService.length > 0;
    },
    getConfectionService() {
      return this.product.confectionService;
    },
    getConfection() {
      return this.product.confection;
    },
    isNDE() {
      return this.product.is_nde;
    },
    isCoupon() {
      return checkProductsIsCoupon(this.product);
    },
    isModalLarge() {
      if (!this.isNDE) {
        return this.getConfection.length >= LARGE_MODAL_MIN_PRODUCTS_COUNT
        || this.getConfectionService.length >= LARGE_MODAL_MIN_PRODUCTS_COUNT;
      }
      return this.getNDEConfectionTypeOrder().some(
        type => this.getNDEConfectionByType(this.product, type).length >= LARGE_MODAL_MIN_PRODUCTS_COUNT,
      );
    },
  },
};
</script>

<style lang="scss">
</style>
